import React from 'react'
import isDeepEqual from 'lodash/isMatch'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Divider from '@mui/material/Divider'

import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import Link from '~/client/components/Link'
import ErrorMessage from '~/client/components/ErrorMessage'
import Timestamp from '~/client/components/Timestamp'
import Form from '~/client/components/Form'
import FormButtonRow from '~/client/components/FormButtonRow'
import JSONSchemaFormInput from '~/client/components/JSONSchemaFormInput'

export default function DataEditForm({
  documentId,
  onSuccess,
  ...props
}) {
  const query = useQuery('documents.getById', { id: documentId })
  const document = query.result
  const [name, setName] = React.useState()
  const [value, setValue] = React.useState()
  const onReset = () => {
    setName(document.name)
    setValue({...document.value})
  }
  React.useEffect(
    () => {
      if (typeof document?.version === 'number') onReset()
    },
    [document?.version]
  )
  const update = useCommand('documents.update', {
    onSuccess(){
      query.reload()
      if (onSuccess) onSuccess()
    }
  })


  const disabled = query.loading || document.disabled || update.pending

  const submittable = name && value && !isDeepEqual(
    {name: document.name, value: document.value},
    JSON.parse(JSON.stringify({name, value}))
  )

  return <Form
    {...props}
    disabled={disabled}
    onSubmit={() => {
      const opts = {id: documentId, name, value}
      if (opts.name || opts.value) update.call(opts)
    }}
  >
    <ErrorMessage error={query.error || update.error} sx={{mb: 2}}/>
    <TextField {...{
      disabled: true,
      required: false,
      fullWidth: true,
      label: 'Template Used',
      name: 'filename',
      sx: {mb: 2},
      value: document.type.name,
      placeholder: ''
    }}/>
    {(document && value)
      ? <>
        <Typography variant="body2">Type: {document.type.type}</Typography>
        <Typography variant="body2">Version: {document.version}</Typography>
        <Typography variant="body2" mb={2}>
          {`Last Updated: `}
          <Timestamp variant="body2" at={document.updatedAt || document.createdAt}/>
          {` by you`}
        </Typography>
        <Divider sx={{mb:2}}/>
        <JSONSchemaFormInput {...{
          schema: document.type.schema,
          uiSchema: document.type.uiSchema || undefined,
          value: value,
          onChange: setValue,
        }}/>
      </>
      : null
    }
    <FormButtonRow {...{
      disabled,
      onReset,
      submittable,
      submitting: update.pending,
      submitText: 'Update',
      submittingText: 'Updating…',
    }}/>
  </Form>
}
